import { NotificationManager } from './notificationManager';
import { ErrorReporter } from './ErrorReporter';
export class OutsidePublic {
    static scrollToAnchor(scrollToId) {
        let aTag = $('#' + scrollToId);
        let offset = aTag?.offset();
        if (offset) {
            $('html,body').animate({ scrollTop: offset.top }, 'slow');
        }
    }
    static lockCheck(clickedElement, textWhileProcessing) {
        if ($(clickedElement).data('locked') === 1)
            return null;
        $(clickedElement).attr('locked', 1);
        var innerHtml = $(clickedElement).html();
        $(clickedElement).html(textWhileProcessing);
        return innerHtml;
    }
    static onSuccessCb(successMessage, idToHideOnSuccess, onSuccessIconCssClass, elementToPlaceSuccessMessage) {
        $('#' + idToHideOnSuccess).hide();
        if (elementToPlaceSuccessMessage !== null) {
            elementToPlaceSuccessMessage.html(successMessage);
        }
        var notificationManager = new NotificationManager();
        notificationManager.toastCustom({
            message: successMessage,
            onCloseCallbackName: null,
            cssIconClass: onSuccessIconCssClass,
            timer: null
        });
    }
    static onErrorCb(errorMessage, clickedElement, clickedElementInnerHtml, elementToPlaceSuccessMessage, elementToPlaceSuccessMessageInnerHtml, onErrorIconCssClass) {
        $(clickedElement).attr('locked', 0);
        if (clickedElementInnerHtml !== null) {
            $(clickedElement).html(clickedElementInnerHtml);
        }
        if (elementToPlaceSuccessMessageInnerHtml !== null &&
            elementToPlaceSuccessMessage !== null) {
            elementToPlaceSuccessMessage.html(elementToPlaceSuccessMessageInnerHtml);
        }
        var notificationManager = new NotificationManager();
        notificationManager.toastCustom({
            message: errorMessage,
            onCloseCallbackName: null,
            cssIconClass: onErrorIconCssClass,
            timer: null
        });
    }
    static executeAjaxCall(url, data, onSuccess, onError, defaultErrorMessage) {
        if (url.endsWith('/'))
            url = url.substring(0, url.length - 1);
        $.ajax({
            url: url,
            method: "POST",
            contentType: 'application/json',
            data: (typeof data !== 'string') ? JSON.stringify(data) : data,
            dataType: "json",
            error: function (res) {
                console.log(res);
                ErrorReporter.ReportAjaxError(url, data, res);
                if (onError)
                    onError(defaultErrorMessage);
            },
            success: function (res) {
                if (res.Succeeded) {
                    if (onSuccess)
                        onSuccess(res.ErrorMessage);
                }
                else {
                    if (onError)
                        onError(res.ErrorMessage);
                }
            }
        });
    }
    static subscribeClick(url, emailId, idToHideOnSuccess, idToPlaceSuccessMessage, onSuccessIconCssClass, onErrorIconCssClass, defaultErrorMessage, textWhileProcessing) {
        var email = $('#' + emailId).val();
        var form = $(FormUtils.getForm($('#' + emailId)[0]));
        var clickedElement = form.find(':submit')[0];
        if (form.valid() && email.length > 0) {
            var clickedElementInnerHtml = OutsidePublic.lockCheck(clickedElement, textWhileProcessing);
            if (clickedElementInnerHtml === null) {
                return;
            }
            var elementToPlaceSuccessMessage = $('#' + idToPlaceSuccessMessage);
            var elementToPlaceSuccessMessageInnerHtml = elementToPlaceSuccessMessage.html();
            OutsidePublic.subscribe(url, email, successMessage => {
                OutsidePublic.onSuccessCb(successMessage, idToHideOnSuccess, onSuccessIconCssClass, elementToPlaceSuccessMessage);
            }, errorMessage => {
                OutsidePublic.onErrorCb(errorMessage, clickedElement, clickedElementInnerHtml, elementToPlaceSuccessMessage, elementToPlaceSuccessMessageInnerHtml, onErrorIconCssClass);
            }, defaultErrorMessage);
        }
    }
    static subscribe(url, subscribeEmail, onSuccess, onError, defaultErrorMessage) {
        var data = {
            SimpleValue: subscribeEmail,
        };
        OutsidePublic.executeAjaxCall(url, data, onSuccess, onError, defaultErrorMessage);
    }
}
window.OutsidePublic = OutsidePublic;
